module.exports = __webpack_public_path__ + "fonts/d5706c0.woff";